import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLanguageStore } from '../../lib/languageStore';
import { translate } from '../../lib/translations';

export function OfficeBackButton({ visible }: { visible: boolean }) {
  const navigate = useNavigate();
  const { language } = useLanguageStore();

  if (!visible) return null;

  return (
    <button
      type="button"
      className="btn btn-link text-primary mb-4 p-0 d-flex align-items-center"
      style={{ minHeight: 44 }}
      onClick={() => navigate('/my-office')}
    >
      <ArrowLeft size={20} className="me-2" aria-hidden="true" />
      {translate('back', language)}
    </button>
  );
}
